<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="structure-next"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title"><span id="calibre_toc_2">Copyright </span>© 2016 by Matt Tran</p>
<p class="chapsoy-title">Published by Mango Media Inc.</p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title">Front Cover Image: Elina Diaz</p>
<p class="chapsoy-title">Back Cover Image: Laura Mejía</p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title">Cover Design: Elina Diaz and Laura Mejía </p>
<p class="chapsoy-title">Interior Design, Theme and Layout: Elina Diaz and Laura Mejía.</p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title">All rights reserved. No part of this publication may be reproduced, distributed or transmitted in any form or by any means without prior written permission.</p>
<p class="chapsoy-title"> </p>
<p class="chapsoy-title">ISBN 978-1-63353-093-5</p>
<div class="calibre1" id="calibre_pb_1"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NGJobHacks_split_001.vue?0cd3fbca